module.exports = __webpack_public_path__ + "6c4a0dbc/img/settings-ico.a214628d.svg";